import React from "react";
import { useState } from "react";
import {
  cancelSubscription,
  giftSubscription,
} from "../../../redux/slices/sidekickuserSlice";
import { useDispatch } from "react-redux";
import { RxCross1 } from "react-icons/rx";
import { toast } from "react-toastify";

export default function SubscriptionPopup({
  mode,
  onClose,
  userId,
  fetchUsers,
}) {
  const [selectedSubscription, setSelectedSubscription] = useState("");
  const dispatch = useDispatch();

  const handleSelectChange = async (e) => {
    const { value } = e.target;
    setSelectedSubscription(value);
  };

  const handleConfirm = async () => {
    if(selectedSubscription === ""){
      toast.error("Please select the plan");
      return;
    }
    const payload = {
      month: selectedSubscription,
      userId,
    };
    const response = await dispatch(giftSubscription(payload));
    if (response?.payload?.code === 200) {
      onClose();
      fetchUsers();
      toast.success(response?.payload?.message);
    } else {
      toast.error("Something went wrong");
    }
  };

  const handleCancelSubscription = async () => {
    const response = await dispatch(cancelSubscription({ userId }));
    if (response?.payload?.code === 200) {
      onClose();
      fetchUsers();
      toast.success(response?.payload?.message);
    } else {
      toast.error("Something went wrong");
    }
  };

  return (
    <div className="fixed inset-0 bg-gray-900 backdrop-blur-sm bg-opacity-50 flex items-center justify-center z-50">
      <div className="relative bg-[#150c3f] p-6 rounded-lg shadow-lg text-center w-full max-w-[460px]">
        <button
          className="absolute top-0 right-0 text-white rounded text-lg"
          onClick={onClose}
        >
          <RxCross1 />
        </button>

        {mode === "giftSubscription" ? (
          <>
            <h2 className="text-white text-3xl mb-3">Select Subscription</h2>
            <select
              className="p-3 bg-[#372F5B] text-white focus:outline-none w-full text-lg rounded-md"
              value={selectedSubscription}
              onChange={handleSelectChange}
            >
              <option value="" disabled>
                Choose plan
              </option>
              <option value="1">1 month</option>
              <option value="6">6 months</option>
              <option value="12">12 months</option>
            </select>
            <button
              className="bg-red-600 text-white px-4 py-2 rounded mt-5"
              type="button"
              onClick={handleConfirm}
            >
              Confirm
            </button>
          </>
        ) : (
          <>
            <h2 className="text-white text-2xl mb-4">Confirm Deletion</h2>
            <p className="text-white mb-4">
              Are you sure you want to remove this subscription?
            </p>
            <div className="flex justify-center gap-4">
              <button
                className="bg-red-600 text-white px-4 py-2 rounded"
                onClick={handleCancelSubscription}
              >
                Delete
              </button>
              <button
                className="bg-gray-400 text-black px-4 py-2 rounded"
                onClick={onClose}
              >
                Cancel
              </button>
            </div>
          </>
        )}
      </div>
    </div>
  );
}
